import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {ICallHistoryItem, ICallPayload} from "../../models/call"

interface ICallState {
  waitingCall: boolean
  data: {
    client_uuid: string
    client_fio: string,
    client_phone: string
    clientCallHistory: ICallHistoryItem[]
  }
}

const initialState: ICallState = {
  waitingCall: true,
  data: {
    client_uuid: "",
    client_fio: "",
    client_phone: "",
    clientCallHistory: []
  }
}

export const callSlice = createSlice({
  name: "call",
  initialState,
  reducers: {
    waiting() {},
    received(state, action: PayloadAction<ICallPayload>) {
      state.waitingCall = false
      state.data.client_uuid = action.payload.client_uuid
      state.data.client_fio = action.payload.clientFio
      state.data.client_phone = action.payload.clientPhone
      state.data.clientCallHistory = action.payload.clientCallHistory
    },
    continueWaiting(state) {
      state.waitingCall = true
      state.data = initialState.data
    },
    stopWaiting(state) {
      state.waitingCall = false
    }
  }
})

export default callSlice.reducer